import React from "react";
import Scholarship from "../components/Scholarship";
import ScholarshipCycle from "../components/ScholarshipCycle";
import TypesOfScholarships from "../components/TypesOfScholarships";

const Scholorship = () => {
  return (
    <div className="gfi-franchise-page-wrapper">
      {}
      <Scholarship />
      <ScholarshipCycle />
      <TypesOfScholarships />
    </div>
  );
};

export default Scholorship;
